import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAutoSolveBlockLevelHistorySelector, useBotDetailsSelector } from '../../../../../redux/selectors/content';
import { dispatchBotDetails, dispatchGetAutoSolveBlockLevelHistory } from '../../../../../redux/actions/content';
import Logs from './Logs';
import WizrUserJourney from '../../../../../components/WizrUserJourney';
import WizrButton from '../../../../../components/WizrButton';
import { ArrowLeftOutlined } from '@ant-design/icons';
import WizrText from '../../../../../components/WizrText';

const AutoSolveTestDetailedLogs = () => {
  const { id: chatBotId, conversationId } = useParams();

  // Selector to get the logs data from Redux
  const blockLevelHistory = useAutoSolveBlockLevelHistorySelector();

  const botDetails = useBotDetailsSelector();
  const botName = botDetails?.agent_config?.agent_name 

  useEffect(() => {
    if (chatBotId && conversationId) {
      dispatchGetAutoSolveBlockLevelHistory(chatBotId, conversationId);
    }
  }, [chatBotId, conversationId]);

  useEffect(() => {
    if (chatBotId) {
      dispatchBotDetails(chatBotId);
    }
  }, [chatBotId]);

  return (
    <div style={{ width: '100%', maxWidth: '100%', margin: 0, padding: '0 24px' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
         
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16,
          marginBottom: 16,
        }}
      >
        <WizrUserJourney
          userJourney={[
            {
              title: (
                <WizrButton
                  icon={<ArrowLeftOutlined style={{ fontSize: '22px', marginRight: '10px' }} />}
                  type="text"
                  text={<WizrText type="h6">{botName}</WizrText>}
                  onClick={() => window.history.back()}
                />
              ),
            },
            { title: 'Test' },
            { title: 'History' },
            { title: 'Detailed Log' },
          ]}
        />
      </div>
      <Logs blockLevelHistory={blockLevelHistory} />
    </div>
  );
};

export default AutoSolveTestDetailedLogs;